import { scrollToPosition } from '/utilities';

const scrollToElement = (element, offset = 0) => {
    const position = window.scrollY + element.getBoundingClientRect().top;

    scrollToPosition(position - offset);
};

export { scrollToElement };
